import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Checkbox,
  ListItemText,
  Snackbar,
  Alert,
  useMediaQuery,
  FormControlLabel,
  Typography,
  CircularProgress,
  Collapse,
  ListItem,
  ListItemButton,
  ListItemIcon,
  Divider,
  Paper,
  IconButton,
  List,
  Autocomplete,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import {
  fetchCustomSMS,
  createMessage,
  fetchCustomers,
  createSMSesBulk,
  fetchCustomersByStatus,
  handleregex,
} from "./components/smsService";
import { fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";
import { DataGrid } from "@mui/x-data-grid";
import { useTheme, InputAdornment } from "@mui/material";
import { tokens } from "../../../theme";
import { mpesaPay } from "../../../data/DynamicTable/DynamicFunctions";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import dayjs from "dayjs"; // For formatting current date & time
import axios from "axios";
import {
  smsservice,
  customerservice,
  reportsManagementUrl,
  companyManagementUrl,
  userManagementUrl,
} from "../../../config";
import {
  ExpandMore,
  ExpandLess,
  Clear,
  Search,
  Refresh,
  Send,
  Schedule,
  Payment,
} from "@mui/icons-material";
const CustomSMSPage = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const RoleGroupId = parseInt(decodedToken.RoleGroupId);
  const userId = parseInt(decodedToken.Id);
  const branchId = parseInt(decodedToken.BranchId);
  const regionId = parseInt(decodedToken.RegionId);
  const CompanyId = parseInt(decodedToken.CompanyId);

  const [message, setMessage] = useState("");
  const [selectedCustomers, setSelectedCustomers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [pastMessages, setPastMessages] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessageText, setErrorMessageText] = useState("");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [successMessageText, setSuccessMessageText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedPastMessageId, setSelectedPastMessageId] = useState("");
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContent, setPreviewContent] = useState({
    message: "",
  });
  const [scheduleEnabled, setScheduleEnabled] = useState(false);
  const [scheduledDate, setScheduledDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );
  const [scheduledTime, setScheduledTime] = useState(dayjs().format("hh:mm"));
  const [meridian, setMeridian] = useState(dayjs().format("A")); // AM or PM
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [searchError, setSearchError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredPastMessages, setFilteredPastMessages] = useState([]);
  const [SmsBalance, setSmsBalance] = useState([]);
  const [expandedFilters, setExpandedFilters] = useState(false);
  const [expandedFilterBy, setExpandedFilterBy] = useState(false);
  const [expandedSearch, setExpandedSearch] = useState(false);
  const [expandedCustomerId, setExpandedCustomerId] = useState(null);
  const [regionData, setRegionData] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const [FOData, setFOData] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [selectedFO, setSelectedFO] = useState(null);
  const [formData, setFormData] = useState({
    phoneNumber: "",
    amount: "",
  });
  const [sendToAllCustomers, setSendToAllCustomers] = useState(false);
  const [searchInput, setSearchInput] = useState("");

  const [totalRowCount, setTotalRowCount] = useState(0);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const [isLoadingMessages, setIsLoadingMessages] = useState(false);

  const base_url = reportsManagementUrl.uri;
  const baseUrl2 = companyManagementUrl.uri;
  const baseUrl3 = userManagementUrl.uri;
  const statuses = [
    "SelectCustomer",
    "isLoanApproved",
    "isLoanCleared",
    "isInArrears",
    "isNonPerforming",
    "isWrittenOff",
    "isLoanDeclined",
    "isFieldOfficerApproved",
    "isBranchApproved",
    "isRegionApproved",
    "isCompanyApproved",
    "isMigrated",
    "isRescheduled",
    "isRebooked",
    "isVerified",
  ];

  const fetchBalanceByCompany = async () => {
    const token = localStorage.getItem("token");
    const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

    const FETCH_SMS_BALANCE = `
      query SmsBalanceByCompany {
        smsBalanceByCompany {
          companyId
          company
          active
          promotionalAmount
          promotionalrate
          transactionalAmount
          smsLimit
        }
      }
    `;

    try {
      const response = await axios.post(
        smsservice.uri,
        {
          query: FETCH_SMS_BALANCE,
        },
        {
          headers: {
            Authorization: formattedToken,
            "Content-Type": "application/json",
          },
        }
      );

      const data = response?.data.data.smsBalanceByCompany;
      setSmsBalance(data);

      if (data.error) {
        console.error("Error fetching SMS Balances:", data.error);
        return [];
      }

      const smsbalance = JSON.parse(data?.results);

      if (!Array.isArray(smsbalance)) {
        throw new Error("Unexpected format for SMS Balances data");
      }

      return smsbalance;
    } catch (error) {
      console.error("Error fetching SMS Balances:", error.message || error);
      return [];
    }
  };
  const handleCustomerSearch = async () => {
    if (!searchTerm.trim()) {
      setSearchError("Please enter a search term");
      return;
    }

    // Extract phone numbers (remove all non-digits first)
    const phoneNumbers = searchTerm
      .replace(/[^\d]/g, " ")
      .split(" ")
      .filter((num) => num.length > 0);

    if (phoneNumbers.length === 0) {
      setSearchError("Please enter at least one phone number");
      return;
    }

    setSearchLoading(true);
    setSearchError(null);

    try {
      const token = localStorage.getItem("token");
      const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

      const allResults = [];

      // Loop through each phone number individually
      for (const phoneNumber of phoneNumbers) {
        try {
          const response = await axios.post(
            customerservice.uri,
            {
              query: `
              {
                dynamicCustomerSearch(customer: {searchTerm: "${phoneNumber}", approval: 3}) {
                  results
                  error
                }
              }
            `,
            },
            {
              headers: {
                Authorization: formattedToken,
                "Content-Type": "application/json",
              },
            }
          );

          const data = response?.data?.data?.dynamicCustomerSearch;

          if (!data.error) {
            try {
              // Parse the results if they exist
              const results = data.results ? JSON.parse(data.results) : [];
              // Add valid results to the accumulated array
              if (Array.isArray(results)) {
                allResults.push(...results);
              } else if (results) {
                allResults.push(results);
              }
            } catch (parseError) {
              console.error(
                `Error parsing results for ${phoneNumber}:`,
                parseError
              );
            }
          }
        } catch (error) {
          console.error(`Search error for ${phoneNumber}:`, error);
        }
      }

      // After all searches complete, update the state
      if (allResults.length > 0) {
        setSearchResults(allResults);
      } else {
        setSearchError("No customers found for the provided phone numbers");
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Overall search error:", error);
      setSearchError("An error occurred during search");
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  };
  useEffect(() => {
    const loadInitialData = async () => {
      setLoading(true);
      try {
        const [messages, customerList] = await Promise.all([
        fetchCustomSMS(page, rowsPerPage), // Use page and rowsPerPage instead of paginationModel
          fetchCustomers(),
          fetchBalanceByCompany(),
        ]);
      console.log("Messages response:", messages);

        const formattedMessages = messages.messages.map((message) => ({
          id: message.id,
          ...message,
        }));

        const formattedCustomers = customerList.map((customer) => ({
          ...customer,
          companyId: customer.companyId || "defaultCompanyId",
          company: customer.company || "Unknown Company",
        }));

        setPastMessages(formattedMessages);
        setTotalRowCount(messages.totalCount);
      } catch (error) {
        console.error("Error loading messages or customers:", error);
      } finally {
        setLoading(false);
      }
    };

    loadInitialData();
  }, []);

    // Replace the handlePaginationModelChange function with this:
    const handlePaginationModelChange = async (pageNumber, pageSize) => {
      setIsLoadingMessages(true);
      try {
        const messagesData = await fetchCustomSMS(pageNumber, pageSize);
        
        const formattedMessages = messagesData.messages.map((message) => ({
          id: message.id,
          ...message,
        }));

        setPastMessages(formattedMessages);
        setTotalRowCount(messagesData.totalCount);
      } catch (error) {
        console.error("Error loading messages:", error);
      } finally {
        setIsLoadingMessages(false);
      }
    };

    
    const handleChangePage = (event, newPage) => {
      console.log("Page change event:", event, "New page:", newPage);
      setPage(newPage = event);
      handlePaginationModelChange(newPage = event, rowsPerPage);
    };

    const handleChangeRowsPerPage = (event) => {
      const newRowsPerPage = parseInt(event.target.value, 10);
      console.log("Rows per page change:", newRowsPerPage);
      setRowsPerPage(newRowsPerPage);
      setPage(0); // Reset to first page when changing page size
      handlePaginationModelChange(0, newRowsPerPage);
    };
  useEffect(() => {
    async function fetchDropdownData() {
      try {
        const [res1, res2, res3] = await Promise.all([
          fetchJsonDynamic("region", null, null, baseUrl2),
          fetchJsonDynamic("branch", null, null, baseUrl2),
          fetchJsonDynamic("allUsers", null, null, baseUrl3),
        ]);

        setRegionData(res1?.results ? JSON.parse(res1.results) : []);
        setBranchData(res2?.results ? JSON.parse(res2.results) : []);
        // Filter users to only include those with RoleGroupId = 5
        const allUsers = res3?.results ? JSON.parse(res3.results) : [];
        const filteredFOData = allUsers.filter(
          (user) => user.RoleGroupId === 5
        );
        setFOData(filteredFOData);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchDropdownData();
  }, []);
  const regionOptions =
    regionData?.map((item) => ({
      parent_key: item.Id,
      value: item.Id,
      label: item.Name,
    })) || [];
  const branchOptions =
    branchData?.map((item) => ({
      parent_key: item.RegionId,
      value: item.Id,
      label: item.Name,
    })) || [];
  const FOOptions =
    FOData?.map((item) => ({
      parent_key: item.BranchId,
      parent_key2: item.RegionId,
      value: item.Id,
      label: `${item.FirstName} ${item.LastName}`,
    })) || [];

  // Handle status filter changes
  const handleStatusChange = async () => {
    setLoading((prev) => ({ ...prev, customers: true }));
    try {
      if (selectedStatuses.includes("SelectCustomer")) {
        const fetchedCustomers = await fetchCustomers(0, 10);
        setCustomers(fetchedCustomers);
      } else {
        const fetchedCustomers = await fetchCustomersByStatus(selectedStatuses);
        setCustomers(fetchedCustomers);
      }
      setSelectedCustomers([]);
    } catch (error) {
      console.error("Error filtering customers:", error);
    } finally {
      setLoading((prev) => ({ ...prev, customers: false }));
    }
  };

  const handleApplySelection = async () => {
    setLoading((prev) => ({ ...prev, customers: true }));
    try {
      if (
        selectedStatuses.length === 0 ||
        selectedStatuses.includes("SelectCustomer")
      ) {
        // Clear customers when no status or "Select Customer" is chosen
        setCustomers([]);
      } else {
        // Fetch customers based on selected statuses
        const fetchedCustomers = await fetchCustomersByStatus(selectedStatuses);
        setCustomers(fetchedCustomers);
      }
      setSelectedCustomers([]); // Always clear selections when filters change
    } catch (error) {
      console.error("Error filtering customers:", error);
    } finally {
      setLoading((prev) => ({ ...prev, customers: false }));
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedCustomers(
      (prev) =>
        prev.includes(id)
          ? prev.filter((customerId) => customerId !== id) // Deselect
          : [...prev, id] // Select
    );
  };

  // Send messages
  const handleSendMessage = async () => {
    if (!message || (!selectedCustomers.length && !searchResults.length)) {
      setErrorMessageText("Please fill in all fields and select customers");
      setShowErrorMessage(true);
      return;
    }

    setLoading((prev) => ({ ...prev, sending: true }));

    try {
      // Combine customers from both sources (filtered list and search results)
      const allSelectedCustomers = [
        ...customers.filter((c) => selectedCustomers.includes(c.Id)),
        ...searchResults.filter((c) => selectedCustomers.includes(c.Id)),
      ].filter(Boolean);

      const smsMessages = allSelectedCustomers.map((customer) => ({
        MobileNumber: customer.MobileNumber,
        body: handleregex(message, customer),
        isActive:1,
        createdBy: customer.CreatedBy,
        companyId: customer.CompanyId || "defaultCompanyId",
      }));

      if (smsMessages.length === 0) {
        throw new Error("No valid customers selected");
      }

      await createSMSesBulk(smsMessages);

      // Handle scheduled messages if enabled
      if (scheduleEnabled) {
        // Add scheduling logic here
      }

      setSuccessMessageText(
        `${smsMessages.length} message(s) sent successfully`
      );
      setShowSuccessMessage(true);

      // Refresh messages
      const messages = await fetchCustomSMS(page, rowsPerPage);
      const formattedMessages = messagesData.messages.map((message) => ({
        id: message.id,
        ...message,
      }));
      setPastMessages(formattedMessages);
      setTotalRowCount(messagesData.totalCount);      
      setMessage("");
      setSelectedCustomers([]);
    } catch (error) {
      console.error("Error sending messages:", error);
      setErrorMessageText("Failed to send messages. Please try again.");
      setShowErrorMessage(true);
    } finally {
      setLoading((prev) => ({ ...prev, sending: false }));
    }
  };
  const handleSendBulkSMS = async () => {
    // Validate inputs
    if (!message) {
      setErrorMessageText("Please enter a message");
      setShowErrorMessage(true);
      return;
    }

    setLoading({ ...loading, sending: true });

    try {
      // Determine role-based parameters
      const regionId = selectedRegion?.value || null;
      const branchId = selectedBranch?.value || null;
      const fieldOfficerId = selectedFO?.value || null;

      // Determine the effective role group ID
      let effectiveRoleGroupId = RoleGroupId;
      if (regionId) effectiveRoleGroupId = 3;
      if (regionId && branchId) effectiveRoleGroupId = 4;
      if (regionId && branchId && fieldOfficerId) effectiveRoleGroupId = 5;

      // Prepare the bulk SMS payload
      const bulkSmsPayload = {
        p_companyid: CompanyId || "defaultCompanyId",
        p_body: message,
        p_userid: effectiveRoleGroupId === 1 ? null : fieldOfficerId || userId,
        p_regionid: regionId,
        p_branchid: branchId,
        p_fieldofficerid: effectiveRoleGroupId >= 5 ? fieldOfficerId : null,
        allcustomer: sendToAllCustomers === true ? 1 : null || null,
      };

      // Send the bulk SMS request
      const response = await axios.post(
        smsservice.uri,
        {
          query: `
        mutation Create_Bulk_Sms($sentBulkSms: Sent_Bulk_SmsInput!) {
          create_Bulk_Sms(sentBulkSms: $sentBulkSms) {
            results
            error
          }
        }
      `,
          variables: {
            sentBulkSms: bulkSmsPayload,
          },
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage
              .getItem("token")
              ?.replace(/"/g, "")}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Handle response
      const result = response.data.data.create_Bulk_Sms;
      if (result.error || result.results !== "1") {
        throw new Error(result.error || "Failed to send bulk SMS");
      }

      // Show success message
      setSuccessMessageText(`Successfully sent SMS messages.`);
      setShowSuccessMessage(true);

      // Refresh data and reset form
      const [messages, balance] = await Promise.all([
        fetchCustomSMS(),
        fetchBalanceByCompany(),
      ]);

      setPastMessages(messages.map((m) => ({ id: m.messageId, ...m })));
      setSmsBalance(balance);
      setMessage("");
      setSelectedRegion(null);
      setSelectedBranch(null);
      setSelectedFO(null);
      setScheduleEnabled(false);
      setSearchResults([]);
      setSearchTerm("");
    } catch (error) {
      console.error("Bulk SMS error:", error);
      setErrorMessageText(
        error.response?.data?.errors?.[0]?.message ||
          error.message ||
          "Failed to send bulk SMS"
      );
      setShowErrorMessage(true);
      setSelectedCustomers([]);
    } finally {
      setLoading({ ...loading, sending: false });
    }
  };

  const handleCustomerChange = (event) => {
    const value = event.target.value;

    if (value.includes("all")) {
      setSelectedCustomers(
        isAllSelected ? [] : customers.map((customer) => customer.FirstName)
      );
    } else if (value.includes("SelectCustomer")) {
      setSelectedCustomers([]); // Clear selection if "Select Customer" is chosen
    } else {
      setSelectedCustomers(value);
    }
  };
  // Handle select all customers
  const handleSelectAll = () => {
    if (selectedCustomers.length === customers.length) {
      setSelectedCustomers([]);
    } else {
      setSelectedCustomers(customers.map((c) => c.Id));
    }
  };
  // Handle customer selection
  const handleCustomerSelection = (customerId) => {
    setSelectedCustomers((prev) =>
      prev.includes(customerId)
        ? prev.filter((id) => id !== customerId)
        : [...prev, customerId]
    );
  };

  const handleSingleCustomerChange = (FirstName) => {
    setSelectedCustomers((prevSelected) =>
      prevSelected.includes(FirstName)
        ? prevSelected.filter((name) => name !== FirstName)
        : [...prevSelected, FirstName]
    );
  };

  const handleCloseSnackbar = () => {
    setShowSuccessMessage(false);
  };

  const resetForm = () => {
    setMessage("");
    setSelectedCustomers([]);
    setSelectedPastMessageId("");
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleTopUp = async (e) => {
    e.preventDefault();
    const phoneNumber = formData.phoneNumber;
    const amountToPay = parseFloat(formData.amount);

    if (!phoneNumber || !amountToPay) {
      alert("Phone number and amount are required!");
      return;
    }

    setLoading(true);

    try {
      const response = await mpesaPay(amountToPay, phoneNumber, null);
      if (response.status === 200) {
        alert("Payment initiated successfully!");
        setIsOpen(false);
      } else {
        alert("Payment failed! Please try again.");
      }
    } catch (error) {
      alert(`Error: ${error}`);
    } finally {
      setLoading(false);
    }
  };

  const handleRowSelection = (params) => {
    const selectedMessage = pastMessages.find((msg) => msg.id === params.id);
    if (selectedMessage) {
      setPreviewContent({
        message: selectedMessage.body,
      });
      setOpenPreview(true);
      setSelectedPastMessageId(selectedMessage.id);
      setMessage(selectedMessage.body);
    }
  };

  const handleDropDownOpen = () => {
    setDropdownOpen(true);
  };

  const handleDropDownClose = () => {
    setDropdownOpen(false);
  };

  const isAllSelected = selectedCustomers.length === customers.length;

  const columns = [
    { field: "id", headerName: "ID", width: 60 },
    { field: "body", headerName: "Message", flex: 1 },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 80,
      valueGetter: (params) =>
        new Date(params.row.createdDate).toLocaleDateString(),
    },
    { field: "status", headerName: "Status", flex: 0.2 },
    {
      field: "isActive",
      headerName: "Action",
      width: 90,
      renderCell: (params) => (
        <Button onClick={() => handleRowSelection(params)}>PREVIEW</Button>
      ),
    },
  ];

  useEffect(() => {
    if (searchQuery.trim() === "") {
      setFilteredPastMessages(pastMessages);
    } else {
      const filtered = pastMessages.filter((msg) =>
        msg.body.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredPastMessages(filtered);
    }
  }, [searchQuery, pastMessages]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleScheduleChange = (event) => {
    setScheduleEnabled(event.target.checked);
    if (event.target.checked) {
      setScheduledDate(dayjs().format("YYYY-MM-DD"));
      setScheduledTime(dayjs().format("hh:mm"));
      setMeridian(dayjs().format("A"));
    }
  };
  const handleRegionChange = (event, newValue) => {
    setSelectedRegion(newValue);
    // Reset branch and FO when region changes
    setSelectedBranch(null);
    setSelectedFO(null);
  };
  const handleBranchChange = (event, newValue) => {
    setSelectedBranch(newValue);
    // Reset FO when branch changes
    setSelectedFO(null);
    // Auto-select the region if not already selected
    if (newValue && !selectedRegion) {
      const region = regionOptions.find(
        (region) => region.value === newValue.parent_key
      );
      setSelectedRegion(region || null);
    }
  };
  const handleFOChange = (event, newValue) => {
    setSelectedFO(newValue);
    // Auto-select branch and region if not already selected
    if (newValue) {
      const branch = branchOptions.find(
        (branch) => branch.value === newValue.parent_key
      );
      const region = regionOptions.find(
        (region) => region.value === newValue.parent_key2
      );
      if (!selectedBranch && branch) setSelectedBranch(branch);
      if (!selectedRegion && region) setSelectedRegion(region);
    }
  };
  const getFilterLabel = () => {
    if (RoleGroupId === 1 || RoleGroupId === 2)
      return "Filter By (Region/Branch/RO)";
    if (RoleGroupId === 3) return "Filter By (Branch/RO)";
    if (RoleGroupId === 4) return "Filter By (RO)";
    return "Filter By";
  };
  const filteredBranchOptions = selectedRegion
    ? branchOptions.filter(
        (branch) => branch.parent_key === selectedRegion.value
      )
    : branchOptions;

  const filteredFOOptions = selectedBranch
    ? FOOptions.filter((fo) => fo.parent_key === selectedBranch.value)
    : selectedRegion
    ? FOOptions.filter((fo) => fo.parent_key2 === selectedRegion.value)
    : FOOptions;

  return (
    <div style={{ padding: "20px" }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <h2>Create and Send Custom SMS</h2>
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <button
            onClick={() => setIsOpen(true)}
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            Top Up
          </button>

          {isOpen && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 1000,
              }}
            >
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  width: "400px",
                  maxWidth: "90%",
                  padding: "20px",
                  position: "relative",
                }}
              >
                <h3 style={{ marginBottom: "15px", fontSize: "20px" }}>
                  Top Up
                </h3>
                <button
                  onClick={() => setIsOpen(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "none",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                  }}
                >
                  &times;
                </button>
                <div>
                  <label style={{ display: "block", marginBottom: "10px" }}>
                    Phone Number
                    <input
                      type="text"
                      value={formData.phoneNumber}
                      onChange={handleInputChanges}
                      name="phoneNumber"
                      placeholder="Enter phone number"
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "8px",
                        marginTop: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </label>
                  <label style={{ display: "block", marginBottom: "10px" }}>
                    Amount
                    <input
                      type="number"
                      value={formData.amount}
                      onChange={handleInputChanges}
                      name="amount"
                      placeholder="Enter amount"
                      style={{
                        display: "block",
                        width: "100%",
                        padding: "8px",
                        marginTop: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    />
                  </label>
                </div>
                <div style={{ textAlign: "right", marginTop: "20px" }}>
                  <button
                    onClick={handleTopUp}
                    disabled={loading}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#4CAF50",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                      marginRight: "10px",
                    }}
                  >
                    {loading ? "Processing..." : "Pay Now"}
                  </button>
                  <button
                    onClick={() => setIsOpen(false)}
                    style={{
                      padding: "10px 20px",
                      backgroundColor: "#f44336",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Box
        display="flex"
        flexDirection={isSmallScreen ? "column" : "row"}
        gap={4}
      >
        <Grid
          container
          spacing={2}
          direction={isSmallScreen ? "column" : "row"}
        >
          {/* Left Side: Business Name, Account No, Credit Balance Table */}
          <Grid item xs={12} md={5}>
            <DataGrid
              rows={SmsBalance}
              columns={[
                { field: "companyId", headerName: "Company ID", flex: 1 },
                {
                  field: "transactionalAmount",
                  headerName: "Transaction Balance",
                  flex: 1,
                },
                {
                  field: "promotionalAmount",
                  headerName: "Promotional Balance",
                  flex: 1,
                },
              ]}
              getRowId={(row) => row.companyId}
              pageSize={10}
              rowsPerPageOptions={[10]}
              autoHeight
              sx={{
                "& .MuiDataGrid-root": { border: "none" },
                "& .MuiDataGrid-cell": { borderBottom: "none" },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: colors.blueAccent[700],
                  borderBottom: "none",
                },
                "& .MuiDataGrid-virtualScroller": {
                  backgroundColor: colors.primary[400],
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "none",
                  backgroundColor: colors.blueAccent[700],
                },
              }}
            />
          </Grid>

          {/* Message Input */}
          <Grid item xs={12} md={6}>
            <Box flex={2} display="flex" flexDirection="column" gap={2}>
              <FormControl fullWidth>
                <TextField
                  label="Custom Message"
                  variant="outlined"
                  multiline
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  required
                />
              </FormControl>

              {/* Filter Section */}
              <Box sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mb: 1,
                  }}
                  onClick={() => setExpandedFilters(!expandedFilters)}
                >
                  <Typography variant="subtitle1">Filter Customers</Typography>
                  {expandedFilters ? <ExpandLess /> : <ExpandMore />}
                </Box>

                <Collapse in={expandedFilters}>
                  <Box
                    sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}
                  >
                    <FormControl sx={{ minWidth: 200 }}>
                      <InputLabel>Customer Status</InputLabel>
                      <Select
                        multiple
                        value={selectedStatuses}
                        onChange={(e) => {
                          if (e.target.value.includes("SelectCustomer")) {
                            setSelectedStatuses(["SelectCustomer"]);
                            setCustomers([]);
                          } else {
                            setSelectedStatuses(e.target.value);
                          }
                        }}
                        renderValue={(selected) =>
                          selected.includes("SelectCustomer")
                            ? "Select Customer"
                            : selected.join(", ")
                        }
                        label="Customer Status"
                        IconComponent={(props) => (
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            {selectedStatuses.length > 0 &&
                            !selectedStatuses.includes("SelectCustomer") ? (
                              <IconButton
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedStatuses([]);
                                  setCustomers([]);
                                  setSelectedCustomers([]);
                                }}
                                sx={{
                                  mr: -1,
                                  "&:hover": {
                                    backgroundColor: "transparent",
                                  },
                                }}
                              >
                                <Clear
                                  sx={{
                                    ml: -4,
                                    "&:hover": {
                                      backgroundColor: "transparent",
                                    },
                                  }}
                                  fontSize="small"
                                  color="action"
                                />
                              </IconButton>
                            ) : (
                              <ExpandMore {...props} />
                            )}
                          </Box>
                        )}
                      >
                        <MenuItem value="SelectCustomer">
                          <Checkbox
                            checked={selectedStatuses.includes(
                              "SelectCustomer"
                            )}
                          />
                          <ListItemText primary="Select Customer" />
                        </MenuItem>
                        {statuses
                          .filter((s) => s !== "SelectCustomer")
                          .map((status) => (
                            <MenuItem key={status} value={status}>
                              <Checkbox
                                checked={selectedStatuses.includes(status)}
                              />
                              <ListItemText primary={status} />
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>

                    <Button
                      variant="contained"
                      onClick={handleStatusChange}
                      disabled={loading.customers}
                      startIcon={
                        loading.customers ? (
                          <CircularProgress size={20} />
                        ) : null
                      }
                    >
                      Apply Filters
                    </Button>
                  </Box>
                </Collapse>
              </Box>

              {/* Customer Selection */}
              {customers.length > 0 && (
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" gutterBottom>
                    Select Customers ({selectedCustomers.length} selected)
                  </Typography>

                  <Paper
                    variant="outlined"
                    sx={{ p: 1, maxHeight: 300, overflow: "auto" }}
                  >
                    <List dense>
                      <ListItem disablePadding>
                        <ListItemButton onClick={handleSelectAll}>
                          <ListItemIcon>
                            <Checkbox
                              edge="start"
                              checked={
                                selectedCustomers.length === customers.length
                              }
                              indeterminate={
                                selectedCustomers.length > 0 &&
                                selectedCustomers.length < customers.length
                              }
                            />
                          </ListItemIcon>
                          <ListItemText primary="Select All" />
                        </ListItemButton>
                      </ListItem>

                      <Divider />

                      {customers.map((customer) => (
                        <ListItem key={customer.Id} disablePadding>
                          <ListItemButton
                            onClick={() => handleCustomerSelection(customer.Id)}
                          >
                            <ListItemIcon>
                              <Checkbox
                                edge="start"
                                checked={selectedCustomers.includes(
                                  customer.Id
                                )}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={`${customer.FirstName} ${customer.OtherNames}`}
                              secondary={customer.MobileNumber}
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </List>
                  </Paper>

                  {/* Load More Button */}
                  {selectedStatuses.includes("SelectCustomer") && (
                    <Button
                      fullWidth
                      variant="outlined"
                      onClick={async () => {
                        setLoading((prev) => ({ ...prev, customers: true }));
                        try {
                          const moreCustomers = await fetchCustomers(
                            customers.length,
                            10
                          );
                          setCustomers((prev) => [...prev, ...moreCustomers]);
                        } catch (error) {
                          console.error("Error loading more customers:", error);
                        } finally {
                          setLoading((prev) => ({ ...prev, customers: false }));
                        }
                      }}
                      disabled={loading.customers}
                      sx={{ mt: 1 }}
                    >
                      {loading.customers ? "Loading..." : "Load More Customers"}
                    </Button>
                  )}
                </Box>
              )}
              {/* Customer Search Section - Collapsible */}
              <Box sx={{ mb: 2, mt: -5 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mb: 1,
                    mt: 1,
                    backgroundColor: "initial",
                    borderRadius: 1,
                  }}
                  onClick={() => setExpandedSearch(!expandedSearch)}
                >
                  <Typography variant="subtitle1">Search Customers</Typography>
                  {expandedSearch ? <ExpandLess /> : <ExpandMore />}
                </Box>

                <Collapse in={expandedSearch}>
                  <Box
                    sx={{
                      p: 1,
                      border: `1px solid ${colors.grey[300]}`,
                      borderRadius: 1,
                    }}
                  >
                    <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        placeholder="Enter multiple phone numbers separated by commas or spaces"
                        value={searchTerm}
                        // Only allow numbers, commas, and spaces
                        onChange={(e) =>
                          setSearchTerm(e.target.value.replace(/[^0-9, ]/g, ""))
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                          endAdornment: searchTerm && (
                            <IconButton
                              onClick={() => {
                                setSearchTerm("");
                                setSearchResults([]);
                                setSearchError(null);
                              }}
                            >
                              <Clear />
                            </IconButton>
                          ),
                        }}
                      />
                      <Typography
                        variant="caption"
                        sx={{ display: "block", my: 1 }}
                      >
                        Enter multiple phone numbers separated by commas or
                        spaces (e.g. 0712345678, 0723456789)
                      </Typography>
                      <Button
                        variant="contained"
                        onClick={handleCustomerSearch}
                        disabled={searchLoading || !searchTerm.trim()}
                        startIcon={
                          searchLoading ? <CircularProgress size={20} /> : null
                        }
                      >
                        Search
                      </Button>
                    </Box>

                    {searchError && (
                      <Alert severity="error" sx={{ mb: 2 }}>
                        {searchError}
                      </Alert>
                    )}

                    {searchResults && searchResults.length > 0 ? (
                      <Paper
                        variant="outlined"
                        sx={{ maxHeight: 400, overflow: "auto" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: 1,
                            backgroundColor: colors.primary[400],
                          }}
                        >
                          <Typography variant="subtitle2">
                            Results ({searchResults.length})
                          </Typography>
                          <Button
                            size="small"
                            onClick={() => {
                              const allSearchResultIds = searchResults.map(
                                (c) => c.Id
                              );
                              setSelectedCustomers((prev) => [
                                ...new Set([...prev, ...allSearchResultIds]),
                              ]);
                            }}
                          >
                            Select All
                          </Button>
                        </Box>

                        <List dense>
                          {searchResults.map((customer) => (
                            <Box key={customer.Id}>
                              <ListItem
                                disablePadding
                                secondaryAction={
                                  <Checkbox
                                    edge="end"
                                    checked={selectedCustomers.includes(
                                      customer.Id
                                    )}
                                    onChange={() =>
                                      handleCustomerSelection(customer.Id)
                                    }
                                  />
                                }
                              >
                                <ListItemButton
                                  onClick={() =>
                                    setExpandedCustomerId(
                                      expandedCustomerId === customer.Id
                                        ? null
                                        : customer.Id
                                    )
                                  }
                                >
                                  <ListItemIcon>
                                    {expandedCustomerId === customer.Id ? (
                                      <ExpandLess />
                                    ) : (
                                      <ExpandMore />
                                    )}
                                  </ListItemIcon>
                                  <ListItemText
                                    primary={`${customer.FirstName} ${customer.OtherNames}`}
                                    secondary={customer.MobileNumber}
                                  />
                                </ListItemButton>
                              </ListItem>

                              <Collapse
                                in={expandedCustomerId === customer.Id}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Box
                                  sx={{
                                    pl: 6,
                                    pr: 2,
                                    py: 1,
                                    backgroundColor: colors.primary[400],
                                  }}
                                >
                                  <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                      <Typography variant="body2">
                                        <strong>ID Number:</strong>{" "}
                                        {customer.IdNoOrPassport || "N/A"}
                                      </Typography>
                                      <Typography variant="body2">
                                        <strong>Email:</strong>{" "}
                                        {customer.EmailAddress || "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <Typography variant="body2">
                                        <strong>Branch:</strong>{" "}
                                        {customer.BranchName || "N/A"}
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Typography variant="body2">
                                        <strong>Address:</strong>{" "}
                                        {customer.PhysicalAddress || "N/A"}
                                      </Typography>
                                    </Grid>
                                  </Grid>
                                </Box>
                              </Collapse>
                              <Divider />
                            </Box>
                          ))}
                        </List>
                      </Paper>
                    ) : (
                      searchResults === null && (
                        <Typography
                          variant="body2"
                          sx={{ p: 2, textAlign: "center" }}
                        >
                          No customers found
                        </Typography>
                      )
                    )}
                  </Box>
                </Collapse>
              </Box>
              {/* Filter By Section */}
              <Box sx={{ mb: 2, mt: -4 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    mb: 1,
                  }}
                  onClick={() => setExpandedFilterBy(!expandedFilterBy)}
                >
                  <Typography variant="subtitle1">
                    {getFilterLabel()}
                  </Typography>
                  {expandedFilterBy ? <ExpandLess /> : <ExpandMore />}
                </Box>

                <Collapse in={expandedFilterBy}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      alignItems: "center",
                      flexWrap: "nowrap", // Prevent wrapping
                      overflowX: "auto", // Horizontal scrolling if needed
                      pt: 0.6, // Padding for scrollbar
                      pb: 0,
                      "& > *": {
                        // Ensure all children have minimum width
                        minWidth: 50,
                      },
                    }}
                  >
                    {/* Region Dropdown - visible to roles 1 & 2 */}
                    {(RoleGroupId === 1 || RoleGroupId === 2) && (
                      <Autocomplete
                        options={regionOptions}
                        value={selectedRegion}
                        onChange={handleRegionChange}
                        sx={{ width: 250 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Region"
                            variant="outlined"
                          />
                        )}
                      />
                    )}

                    {/* Branch Dropdown - visible to roles 1-3 */}
                    {(RoleGroupId === 1 ||
                      RoleGroupId === 2 ||
                      RoleGroupId === 3) && (
                      <Autocomplete
                        options={filteredBranchOptions}
                        value={selectedBranch}
                        onChange={handleBranchChange}
                        sx={{ width: 250 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Branch"
                            variant="outlined"
                          />
                        )}
                      />
                    )}

                    {/* Field Officer Dropdown - visible to roles 1-4 */}
                    {(RoleGroupId === 1 ||
                      RoleGroupId === 2 ||
                      RoleGroupId === 3 ||
                      RoleGroupId === 4) && (
                      <Autocomplete
                        options={filteredFOOptions}
                        value={selectedFO}
                        onChange={handleFOChange}
                        sx={{ width: 250 }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select RO"
                            variant="outlined"
                          />
                        )}
                      />
                    )}

                    {/* <Button
        variant="contained"
        onClick={handleFilterBySelection}
        disabled={loading.filtering}
        startIcon={loading.filtering ? <CircularProgress size={20} /> : null}
      >
        Apply Filters
      </Button> */}
                  </Box>
                </Collapse>
              </Box>
              {/* Send to all customers  section */}
              <Box sx={{ mb: 2, mt: -4 }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={sendToAllCustomers}
                      onChange={(e) => setSendToAllCustomers(e.target.checked)}
                    />
                  }
                  label={
                    <Typography variant="body1">
                      {RoleGroupId === 1 || RoleGroupId === 2
                        ? "Send to all Company customers"
                        : RoleGroupId === 3
                        ? "Send to all Region customers"
                        : RoleGroupId === 4
                        ? "Send to all Branch customers"
                        : "Send to all My customers"}
                    </Typography>
                  }
                />
              </Box>

              <Box display="flex" flexDirection="column" gap={2} mt={-2}>
                {/* Checkbox for scheduling */}
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={scheduleEnabled}
                      onChange={handleScheduleChange}
                    />
                  }
                  label="Schedule Date & Time"
                />

                {/* Date & Time Inputs (only visible if checkbox is checked) */}
                {scheduleEnabled && (
                  <Box display="flex" gap={1} alignItems="center">
                    {/* Date Input */}
                    <TextField
                      label="Date"
                      type="date"
                      value={scheduledDate}
                      onChange={(e) => setScheduledDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />

                    {/* Time Input */}
                    <TextField
                      label="Time"
                      type="time"
                      value={scheduledTime}
                      onChange={(e) => setScheduledTime(e.target.value)}
                      inputProps={{ step: 300 }}
                    />

                    {/* AM/PM Dropdown */}
                    <Select
                      value={meridian}
                      onChange={(e) => setMeridian(e.target.value)}
                      displayEmpty
                      sx={{ width: "80px" }}
                    >
                      <MenuItem value="AM">AM</MenuItem>
                      <MenuItem value="PM">PM</MenuItem>
                    </Select>
                  </Box>
                )}
              </Box>

              {/* Send Button */}
              <Button
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                onClick={
                  selectedRegion ||
                  selectedBranch ||
                  selectedFO ||
                  sendToAllCustomers
                    ? handleSendBulkSMS
                    : handleSendMessage
                }
                disabled={
                  loading.sending ||
                  !message ||
                  (!(
                    selectedRegion ||
                    selectedBranch ||
                    selectedFO ||
                    sendToAllCustomers
                  ) &&
                    !selectedCustomers.length &&
                    !searchResults.length)
                }
                // onClick={handleSendMessage}
                // disabled={loading.sending || !message || !selectedCustomers.length}
                startIcon={
                  loading.sending ? <CircularProgress size={20} /> : <Send />
                }
              >
                {loading.sending ? "Sending..." : "Send Message"}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box m="40px 0 0 0" height="75vh" display="flex" flexDirection="column">
        {/* Search Section */}
        <Box display="flex" justifyContent="flex-start" mt={-2} mb={-4}>
          <TextField
            label="Search Messages"
            variant="outlined"
            value={searchQuery}
            onChange={handleSearchChange}
            style={{
              width: "300px",
              backgroundColor: "#f0f0f0",
              borderRadius: "5px",
            }}
            InputProps={{
              sx: {
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "#bdbdbd" },
                  "&:hover fieldset": { borderColor: "#9e9e9e" },
                  "&.Mui-focused fieldset": { borderColor: "#757575" },
                },
              },
            }}
          />
        </Box>
        {/* DataGrid for Past Messages */}
        <Box
          m="40px 0 0 0"
          height="75vh"
          sx={{
            width: "100%",
            "& .MuiDataGrid-root": {
              border: "1px solid #aaa",
            },
            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid #888",
              borderRight: "1px solid #888",
              whiteSpace: "normal",
              wordBreak: "break-word",
              display: "flex",
              alignItems: "flex-start",
              padding: "8px",
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.blueAccent[700],
              borderBottom: "2px solid #666",
              borderRight: "1px solid #888",
              fontWeight: "bold",
              fontSize: isSmallScreen ? "12px" : "14px",
            },
            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[400],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid #666",
              backgroundColor: colors.blueAccent[700],
            },
          }}
        >
          <DataGrid
            rows={[...filteredPastMessages].sort((a, b) => b.id - a.id)}
            columns={columns.map((col) =>
              col.field === "body"
                ? {
                    ...col,
                    flex: 2,
                    renderCell: (params) => (
                      <Box
                        sx={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                          display: "block",
                          width: "100%",
                          overflow: "hidden",
                        }}
                      >
                        {params.value}
                      </Box>
                    ),
                  }
                : col
            )}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 50]}
            rowCount={searchQuery.trim() === "" ? totalRowCount : filteredPastMessages.length}
            paginationMode={searchQuery.trim() === "" ? "server" : "client"}
            loading={isLoadingMessages || loading}
            getRowId={(row) => row.id}
            autoHeight
          />
        </Box>
      </Box>

      {/* Snackbar for success messages */}
      <Snackbar
        open={showSuccessMessage}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="success">
          {successMessageText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showErrorMessage}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessageText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={showErrorMessage}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity="error"
          sx={{ width: "100%" }}
        >
          {errorMessageText}
        </Alert>
      </Snackbar>
      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogContent>
          <p>{previewContent.message}</p>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenPreview(false)}
            variant="contained"
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CustomSMSPage;
